import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Lọc HTML nguy hiểm (script, event handler...) nhưng giữ format cơ bản.
 * Dùng: [innerHTML]="noiDung | safeHtml"
 * Không dùng bypassSecurityTrustHtml với nội dung user.
 */
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): string {
    if (value == null || value === '') {
      return '';
    }
    // Angular sanitize: bỏ script/javascript: onclick...; giữ p, b, i, ul, a, ...
    return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
  }
}
